/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ibanfalsch1Inputs */

const de__field_ibanfalsch1 = /** @type {(inputs: _Field_Ibanfalsch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IBAN falsch`)
};

/**

* @param {_Field_Ibanfalsch1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ibanfalsch1 = /** @type {((inputs?: _Field_Ibanfalsch1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ibanfalsch1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_ibanfalsch1(inputs)
});
export { _field_ibanfalsch1 as "_field_ibanFalsch" }